import { contentAPI, checkoutAPI, depictAPI } from '../config';

const getDataOptions = (body) => {
	let cookies;
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	if (typeof window !== 'undefined' && document.cookie) {
		cookies = document.cookie.split(';').reduce((acc, cookie) => {
			const [key, value] = cookie.split('=').map((section) => section.trim());
			return { ...acc, [key]: value };
		}, {});
	}

	const previewCode = cookies ? cookies.previewCode : false;
	if (previewCode) body.previewCode = previewCode;

	if (!body.previewCode) delete body.previewCode;
	if (!body.forceCountry) delete body.forceCountry;
	if (!body.country) delete body.country;
	if (body.forceCountry && body.country) delete body.country;
	if (!body.market) delete body.market;
	if (!body.pricelist) delete body.pricelist;
	if (!body.campaignSite) delete body.campaignSite;

	if (typeof process !== 'undefined' && process.env.API) {
		fetchOptions.headers = {
			'api-authorization': process.env.API,
		};
		if (body.ip) fetchOptions.headers['x-forwarded-for'] = body.ip;
		delete body.ip;
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

const getCheckoutOptions = (token, body, method) => {
	const fetchOptions = {
		mode: 'cors',
		cache: 'no-cache',
		headers: {},
	};

	fetchOptions.method = method;
	if (typeof process !== 'undefined' && process.env.CHECKOUT_API) {
		fetchOptions.headers['API-Authorization'] = process.env.CHECKOUT_API;
	}

	if (token) fetchOptions.headers.Accept = `application/json, text/plain, */*; api-token:${token}`;
	else fetchOptions.headers.Accept = 'application/json, text/plain, */*;';

	if (typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchCheckout = (path, token, body = {}, method = 'GET') => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	return fetch(`${checkoutAPI}${encodedPath}`, getCheckoutOptions(token, body, method)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

const fetchDepict = (path, params = {}) => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	const getString = Object.keys(params).reduce((acc, key) => `${acc}${key}=${params[key]}&`, '').slice(0, -1);
	return fetch(`${depictAPI}${encodedPath}?${getString}`).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

export { fetchData, fetchCheckout, fetchDepict };
